import { motion } from "framer-motion";
import { LogoMark } from "./brand";

export const Header = () => {
  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50"
    >
      <div className="backdrop-blur-md bg-[#C6D5E0]/70 border-b border-white/40">
        <div className="max-w-7xl mx-auto flex items-center justify-between px-5 sm:px-8 py-3">
          <div
            data-testid="header-logo"
            className="flex items-center pointer-events-none select-none"
          >
            <LogoMark className="h-14 sm:h-20 w-auto" viewBox="20 400 965 250" />
          </div>

          <nav className="hidden sm:flex items-center gap-8 text-[0.7rem] uppercase tracking-[0.28em] text-[#5a3b44] font-medium">
            <a
              href="https://manhattan-gelato.emergent.host"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-cart"
              className="hover:text-[#800020] transition-colors duration-300"
            >
              The Cart
            </a>
            <a
              href="https://santachiaragelati.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-create"
              className="hover:text-[#800020] transition-colors duration-300"
            >
              Create
            </a>
            <a
              href="https://www.santachiaracaffe.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-location"
              className="hover:text-[#800020] transition-colors duration-300"
            >
              Locations
            </a>
          </nav>
        </div>
      </div>
    </motion.header>
  );
};
